<template>
  <div>
    <div class="tTitle mt30">
      练习
      <span>(长按图片保存至手机)</span>
      <!-- <i @click="checkAnswer">查看答案</i> -->
    </div>
    <div class="imgContent">
      <div
        v-for="(img,index) in unitImg"
        :key="index"
      >
        <div class="pb30">
          <img
            :src="contentHost+img.smallPath"
            @click="viewPhoto(index)"
          />
        </div>
      </div>
    </div>
    <div class="banner">
      <img :src="require('@/assets/images/machine.png')" />
    </div>
    <div
      class="btnTop"
      @click="jumpTop"
      v-if="backTopShow"
    ></div>
  </div>
</template>

<script>
import paramsHelper from '@/assets/js/parametersHelper'
export default {
    name: 'Exam',
    data () {
        return {
            backTopShow: false,
            contentHost: '',
            unitImg: [],
            msg: '网络数据请求异常',
            imgShow: false,
            imgIndex: 0,
            pos: 0,
            images: []
        }
    },
    created () {
        var that = this;
        let { pos } = paramsHelper.decode(this.$route.query.params)
        var unitObj = JSON.parse(sessionStorage.c_contentContents);
        var host = that.contentHost = sessionStorage.c_host;
        that.pos = pos;
        var unit = that.unitImg = unitObj[pos];
        var imgurls = [];
        for (var i = 0, len = unit.length; i < len; i++) {
            var path = unit[i].path;
            var imgurl = host + path;
            imgurls.push(imgurl);
        }
        that.images = imgurls;

    },
    mounted () {

    },
    computed: {

    },
    methods: {
        jumpTop: function () {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        checkAnswer: function () {
            var pos = this.pos + 1;
            this.$router.push({
                name: 'ExamAnswer',
                query: { params: paramsHelper.encode({ pos }),lessonId:this.$route.query.lessonId }
            })
        },
        // viewMachine: function () {
        //     window.location.href = 'https://www.youxuepai.com/market/sync_experience_type/index.html#/home';
        // },
        changeImg: function (index) {
            this.imgIndex = index;
        },
        viewPhoto: function (index) {
            var that = this;
            this.$ImagePreview({
                images: that.images,
                startPosition: index,
                onClose () {
                    // do something
                }
            });
        }
    }
}
</script>

<style scope lang="less">
</style>
